<template src="./AddReportConfig.html"></template>
<script>
import { notifyWarn, notify, notifyError, notifyApiError } from '@/utils/notification-helper';
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("reportConfig");
import { MESSAGES } from "@/utils/constants";
export default {
  data: function () {
    return {
        add: this.$route.params.add,
        reportData: {},
        expand: true,
        reportName: null,
        description: null,
        configuration: null,
        clientSpecific: false,
        yesNoList: [
         { name: "Yes", val: true },
         { name: "No", val: false },
        ],
        visible: false,
        group: null,
    }
  },
  methods: {
    goToListPage: function () {
      this.$store.commit("reportConfig/cancel");
      this.$router.push({ name: "report" });
    },
    expandPanel() {
      let header = document.querySelectorAll("#panelbar .k-header");
      let element = document.querySelectorAll("#panelbar .k-content")[0];
      element.setAttribute("style", "display:block !important");
      header[0].addEventListener("click", () => {
        if (element.getAttribute("style") == "display: block;") {
          element.setAttribute("style", "display:none !important");
        }
      });
    },
    isJSONString(str) {
      try {
        JSON.parse(str);
      } catch(e) {
        return false
      }
      return true
    },
    async getDataOnload() {
      if (!this.$route.params.add) {
        this.deviceEditData = this.$store.getters["reportConfig/getEditReport"];
        this.reportName= this.deviceEditData.name
        this.description= this.deviceEditData.description
        this.configuration= this.deviceEditData.configuration
        this.group= this.initialData.reportGroups.find(rep => rep.id === this.deviceEditData.reportGroupID)
        this.clientSpecific= this.deviceEditData.isClientSpecific
        this.visible= this.deviceEditData.isVisible
      }
    },
    addReport() {
      this.configuration = this.configuration===''?null: this.configuration
      if(this.isJSONString(this.configuration)) {
        if(this.reportName && this.description && this.group) {
          this.reportData= {
            Name: this.reportName,
            Description: this.description,
            Configuration: this.configuration,
            ReportGroupId: this.group?this.group.id:null,
            IsClientSpecific: this.clientSpecific === "true"? true: false,
            IsVisible: this.visible === "true"? true: false,
          }
          if (this.add) {
          this.$store.dispatch("reportConfig/addReport", this.reportData)
            .then((data) => {
              if (data.status) {
                notify(MESSAGES.RECORD_CREATE_SUCCESS);
                this.goToListPage();
                this.clearEntries();
              } else {
                notifyWarn(data.message);
              }
            })
            .catch((err) => {
              try {
                notifyError(err.response.data.message);
              } catch (error) {
                notifyApiError({ message: "Something went wrong" });
              }
            });
          }else {
          this.$store.dispatch("reportConfig/updateReport", this.reportData)
            .then((data) => {
                if(data.status) {
                    notify(MESSAGES.CHANGES_SAVE_SUCCESS);
                    this.goToListPage();
                    this.clearEntries();
                } else {
                    notifyWarn(data.message);
                }
            })
            .catch(notifyApiError);
          }
        }
      } else {
        notifyWarn("Make sure configuration in proper JSON Format")
      }   
    },
    clearEntries: function () {
      this.reportName= null
      this.description= null
      this.configuration= null
      this.group= null,
      this.clientSpecific= false
      this.visible= false
    },
  },
  computed: {
    ...mapState(["initialData"]),
    getGroupTypes() {
      return this.initialData.reportGroups;
    },
  },
  mounted() {
    this.expandPanel();
    this.getDataOnload()
  },
}
</script>
